import clsx from "clsx";
import PropTypes from "prop-types";
import * as React from "react";
import { Avatar } from "../../themeV2";
import shared from "../../themeV2/shared.module.css";
import css from "./AvatarStack.module.css";

const moreLabel = (count) => `${count} more`;

export default function AvatarStack({
  items,
  overflow = 0,
  size = "md",
  label,
  overflowLabel = moreLabel,
  className,
}) {
  if (items.length === 0) return null;

  const isListed = Boolean(label);
  const Root = isListed ? "ul" : "span";
  const Item = isListed ? "li" : "span";
  const rootProps = isListed
    ? { "aria-label": label }
    : { "aria-hidden": true };

  return (
    <Root className={clsx(css.stack, css[size], className)} {...rootProps}>
      {items.map((item, index) => (
        <Item
          key={item.key}
          className={css.item}
          style={{ zIndex: items.length - index }}
        >
          <Avatar src={item.src} alt={isListed ? item.alt : ""} size={size} />
        </Item>
      ))}
      {overflow > 0 && (
        <Item className={clsx(css.item, css.more)}>
          <span aria-hidden="true">+{overflow}</span>
          {isListed && (
            <span className={shared.visuallyHidden}>
              {overflowLabel(overflow)}
            </span>
          )}
        </Item>
      )}
    </Root>
  );
}

AvatarStack.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      src: PropTypes.string,
      alt: PropTypes.string,
    }),
  ).isRequired,
  overflow: PropTypes.number,
  size: PropTypes.oneOf(["sm", "md"]),
  label: PropTypes.string,
  overflowLabel: PropTypes.func,
  className: PropTypes.string,
};
